// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3MeLF","header":"ReportDetails_header__ymzDr","title":"ReportDetails_title__1wCct","left":"ReportDetails_left__3xy42"};